import React, { useEffect,useState} from 'react';
import { useDispatch,useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';

import { fetchLatestReportDate as fetchLatestReportDateService, fetchReports } from 'services/modules/vapt/report';
import { fetchSeverities as fetchSeveritiesService} from 'services/modules/vapt/data';
import { setLoading } from 'stores/modules/idp/authreducer';

import Graph from './Graph';
import ThreatActorGeography from './ThreatActorGeography';
import SignificantThreats from './SignificantThreats';
import CurrentAnalysis from './CurrentAnalysis';
import Loader from 'components/Loader';
import Breadcrumbs from 'config/Breadcrumb';

import {Card,CardContent} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';

function DashboardPage() {
  // Redux dispatch
  const dispatch =useDispatch();

  // use location hook
  const location = useLocation();

  // query params
  const searchParams = new URLSearchParams(location.search);
  const categorySlug = searchParams.get('category');

  // State variables
  const [category,setCategory]=useState("");
  const [categoryLabel,setCategoryLabel]=useState("");
  const subCategory = searchParams.get('subcategory')
  const [progress,setProgress] = useState(false);
  const [report,setReport] = useState("")
  const dimension = searchParams.get("dimension");
  const [currentPath, setCurrentPath] = useState(['Dashboard']);

 // Redux selectors
 const reportDateContainer = useSelector((state) => state.vaptReport.latestReportDate);
 const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
 const vaptDimensionsContainer = useSelector((state)=>state.vaptData.vaptDimensions);
 const loading = useSelector((state) => state.auth.loading);
 const errors = useSelector((state) => state.vaptReport.errors);
  
  // sets the bread crumbs
  useEffect(()=>{
    if (categoryLabel && subCategory){
      setCurrentPath(['Dashboard', categoryLabel, subCategory]);
    }
    if (categoryLabel && subCategory && dimension && vaptDimensionsContainer?.length>0) {
      const categories = vaptDimensionsContainer?.find(cat => cat.slug === categorySlug);
      const dimensions = categories?.Dimensions?.filter((dim)=>dim.slug === dimension).map((dim)=> dim.label)
      setCurrentPath(['Dashboard', categoryLabel, subCategory, dimensions[0]]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryLabel, subCategory, dimension]);

  // useEffect hook fetches the ECS severities
  useEffect(() => {
    dispatch(setLoading(true))
    const fetchSeveritiesData = async () =>{
      await dispatch(fetchSeveritiesService({ }));
    };
    fetchSeveritiesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // Fetches the company report
  const fetchCompanyReport = async () =>{
   const domain = selectedCompanyContainer.domain;
   const categoryId = vaptDimensionsContainer?.filter((cat)=> cat?.slug === categorySlug)?.map((cat)=> cat._id)
   const categoryName = vaptDimensionsContainer?.filter((cat)=> cat?.slug === categorySlug)?.map((cat)=> cat.label);
   setCategoryLabel(categoryName[0]);
   setCategory(categoryId[0]);
   let params = {domain:domain,category:categoryId[0],subcategory:subCategory};
   dispatch(fetchLatestReportDateService({ params }));
};

// Checks whether company has a completed report or not and sets report date if there is a completed report else shows a message to user
useEffect(() => {
  if (selectedCompanyContainer && errors==="Report not found") {
    dispatch(setLoading(false));
    const fetchReport = async () => {
      const domain = selectedCompanyContainer.domain;
      let params = { domain: domain };
      let response = await fetchReports(params);
      let results = response?.data?.results
      let progress = results?.some(report => report?.reportStatus !== "CANCELLED" && report?.reportStatus !== "COMPLETED")
      let report = results?.find(report=>report?.reportStatus !== "CANCELLED" && report?.reportStatus !== "COMPLETED")
      setReport(report)
      setProgress(progress)
    };
    fetchReport();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedCompanyContainer,errors]);


  // useEffect hook fetches the latest report date based on domain
  useEffect(()=>{
    if (selectedCompanyContainer){
      fetchCompanyReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedCompanyContainer, categorySlug,subCategory]);

  return (
    <div style={{position:'relative'}}>
     {loading && (
        <div className="loader-overlay-dashboard">
          <Loader />
        </div>
      )}

      {errors === "Report not found" ? (
        <div className="dived-card cell-items">
          <Card className="d-block py-3 cap-dashboard-container">
            <CardContent>
              <h5 className="rating-value" style={{fontWeight:'normal'}}>
                <InfoIcon className='cap-info-icon' /> <br />
                {progress  ? (
                  <>
                  <div>The requested report is currently running</div>
                  <br/>
                  <div>Report Id : <b>{report?.reportId}</b></div>
                  <div>Report Date : {report?.createdAt?.substring(0,10)}</div>
                  </>
                ) : (
                  <>
                  <div>Welcome to the VAPT Dashboard</div>
                  <div>Please request for a new scan</div>
                  </>
                )}
              </h5>
            </CardContent>
          </Card>
        </div>
      ) : (
        <div>
          <div className="row wrapper-row rounded-10" >
            <Breadcrumbs paths={currentPath} />
            <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-3 rating-flex">
            <Graph chartID="gauge-one" reportDate={reportDateContainer} categoryId={category} subcategory={subCategory}/>
              <div className="vertical-line"></div>
            </div>
            <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-9">
              <CurrentAnalysis categoryId={category} subcategory={subCategory}/>
            </div>
          </div>  
            
          <div className="row mt-md col-gutter-md">
            <div className="col-8 col-xs-12 col-sm-12 col-md-12 col-lg-8 pt-0">
            <ThreatActorGeography  category={category} subcategory={subCategory}/>
            </div>
            <div className="class=col-4 col-xs-12 col-sm-12 col-md-12 col-lg-4 pt-0">
              <div className="significant-threat rounded-10">
                <SignificantThreats categoryId={category} subcategory={subCategory}/>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
};

export default DashboardPage;